import React from 'react';
import tw from 'tailwind-styled-components';


function Text1() {
    return (
        <Main>
            <Heading>Latest For You</Heading>
            <Subheading>Discover the newest arrivals handpicked just for you. Fresh styles and trending products await!</Subheading>
        </Main>
    );
}

const Main = tw.div`container mx-auto px-4 my-5 md:my-10`;
const Heading = tw.div`text-3xl font-bold text-center text-gray-800 my-2`;
const Subheading = tw.div`text-center text-gray-600 max-w-2xl mx-auto`;

export default Text1;
